import React, { useState, useEffect, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelBody } from '../../components/panel/panel.jsx';
import Api from '../../api/global.service';
import BlockUi from 'react-block-ui';
import env from '../../environment.js';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import { Colors } from '../../constants/Colors.js';
import GoogleMapReact from 'google-map-react';
import { getUsaSic, getUsaComiteEvaluacion, useCoopConfig } from '../../components/content/coop-config.jsx';
import CuentasResumenTotales from '../../components/dashboards/productores/cuentas-resumen-totales.js';
import CuentasResumenCategorias from '../../components/dashboards/productores/cuentas-resumen-categorias.js';
import CuentasResumenGeneros from '../../components/dashboards/productores/cuentas-resumen-generos.js';
import CuentasResumenEdades from '../../components/dashboards/productores/cuentas-resumen-edades.js';
import MarkerInfoWindowParcela from '../../components/map/marker-infowindow-parcela.jsx';
import useEtiquetas from '../../hooks/useEtiquetas';
import transformWord from '../../utils/transformWord';
import descargaKML from '../../utils/downloadKML.js';
import LinkDownloadDashboard from '../../components/link/link-download-dashboard.jsx';
import AvancesFilters from '../../components/dashboards/home/avances-filters.jsx';
import ParcelasResumenTotales from '../../components/dashboards/parcelas/parcelas-resumen-totales.js';
import useParcelasAll from '../../hooks/useParcelasAll';
import AvancesSICCoop from '../../components/dashboards/home/avances-sic-coop.jsx';
import AvancesSICML from '../../components/dashboards/home/avances-sic-ml.jsx';
import AvancesComiteCoop from '../../components/dashboards/home/avances-comite-coop.jsx';

const InicioResume = () => {
  const coopConfig = useCoopConfig();
  const [etiquetas, setEtiquetas] = useState({});
  const [idCiclo, setIdCiclo] = useState(0);
  const [blockingMultiBar, setBlockingMultiBar] = useState(true);
  const [blockingMap, setBlockingMap] = useState(false);
  const [blockingAvances, setBlockingAvances] = useState(false);
  const [totalesP, setTotalesP] = useState(0);
  const [dataGraficaMunicipios, setDataGraficaMunicipios] = useState([]);
  const [dataGraficaLocalidades, setDataGraficaLocalidades] = useState([]);
  const [dataCuentas, setDataCuentas] = useState([]);
  const [isLocalidades, setIsLocalidades] = useState(false);
  const [tipoGrafica, setTipoGrafica] = useState('categoria');
  const [map, setMap] = useState(null);
  const [maps, setMaps] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [selectedElement, setSelectedElement] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [showInfoWindow, setInfoWindowFlag] = useState(true);
  const [dataForKML, setDataForKML] = useState([]);
  const center = {
    lat: 17,
    lng: -92,
  };
  const zoom = 6;
  const usaSic = getUsaSic();
  const usaComiteEvaluacion = getUsaComiteEvaluacion();
  const [dataAvances, setDataAvances] = useState([]);
  const [dataAvancesTotal, setDataAvancesTotal] = useState([]);
  const avances = createRef();
  const { etiquetas: etiquetasParcela } = useEtiquetas();
  // Only the SIC dashboard shows ParcelasResumenTotales, so skip the request otherwise
  const { parcelas: parcelasAll, blocking: blockingParcelasAll } = useParcelasAll(Number(usaSic) === 1 ? idCiclo : 0);

  useEffect(() => {
    // coopConfig etiquetas >> dashboards Café, Miel, Cacao, Otro
    getEtiquetas();
    // dashboard Miel || No SIC maps
    if (maps) {
      // Clear all previous polygons in map
      polygons.map(p => p.setMap(null));
      const tempPolygons = [];
      // Add new polygons in map
      markers.forEach(function(marker) {
        if (marker.poligono !== null) {
          let poligono = JSON.parse(marker.poligono);
          let poligono_data = poligono.coordinates[0].map(function(p, index) {
            return { lat: p[1], lng: p[0] };
          });
          var polygon = new maps.Polygon({
            paths: poligono_data,
            strokeColor: '#ffffff', //marker.cuenta_categoria_color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#ffffff', //marker.cuenta_categoria_color,
            fillOpacity: 0.35,
          });
          polygon.setMap(map);
          tempPolygons.push(polygon);
        }
      });
      setPolygons(tempPolygons);
    }

    // infinite scrolling for avances
    // const avancesContainer = document.getElementsByClassName(
    //   "card-avances-body"
    // )[0];
    // const handleAvancesScroll = async () => {
    //   const { scrollTop, clientHeight, scrollHeight } = avancesContainer;
    //   if (
    //     scrollTop + clientHeight >= scrollHeight - 1 &&
    //     dataAvances.length < pagAvances.total
    //   ) {
    //     await getAvanceSIC(); // load data
    //   }
    // };
    // avancesContainer.addEventListener("scroll", handleAvancesScroll);
    // return () => {
    //   avancesContainer.removeEventListener("scroll", handleAvancesScroll);
    // };
  }, [map, maps, markers, coopConfig.config]);

  const getEtiquetas = async () => {
    setEtiquetas({ parcela: await coopConfig.etiquetaParcelas() });
  };

  const getAvanceMunicipios = async value => {
    setBlockingMultiBar(true);
    const response = await Api.search('dashboard/avances/municipios', {
      filter: [{ column: 'id_ciclo', operator: '=', value: value.target.id }],
    });
    if (response.status == 200) {
      let dataResponse = response.data;
      setDataGraficaMunicipios(dataResponse);
      // get data for total productores
      const responseCuentas = await Api.search('cuentas', {
        filter: [
          { column: 'id_ciclo', operator: '=', value: value.target.id },
          { column: 'confirmado', operator: '=', value: 1 },
        ],
        // sort: [{ column: 'clave_tx', sort: 'asc' }],
      });
      if (responseCuentas.status == 200) {
        setDataCuentas(responseCuentas.data);
      }
    }
    setBlockingMultiBar(false);
  };

  const getAvanceLocalidades = id_municipio => {
    setBlockingMultiBar(true);
    Api.search('dashboard/avances/localidades', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: idCiclo },
        { column: 'id_municipio', operator: '=', value: id_municipio },
      ],
    })
      .then(response => {
        setBlockingMultiBar(false);
        let dataResponse = response.data;
        setDataGraficaLocalidades(dataResponse);
        setIsLocalidades(true);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        // console.log('e', e);
        setBlockingMultiBar(false);
      });
  };

  const getKmlData = ciclo => {
    Api.search('parcelas_kml', {
      filter: [{ column: 'id_ciclo', operator: '=', value: ciclo }],
    })
      .then(response => {
        setDataForKML(response.data);
      })
      .catch(e => {
        // console.log('e>>>', e);
      });
  };

  const setFilter = value => {
    setIdCiclo(value.target.id);
    getAvanceMunicipios(value);
    if (Number(usaSic) !== 1) {
      getTotalesParcelasCuentas(value);
      getKmlData(value.target.id);
    } else {
      // getTotalesParcelasGeos(value);
      getAvanceSIC(value);
    }
    // map
    setBlockingMap(true);
    Api.search('parcelas', {
      filter: [
        { column: 'centroide_lat', operator: '!=', value: 'null' },
        { column: 'centroide_lng', operator: '!=', value: 'null' },
        { column: 'id_ciclo', operator: '=', value: value.target.id },
      ],
    })
      .then(response => {
        setMarkers(response.data);
        setBlockingMap(false);
      })
      .catch(e => {
        setBlockingMap(false);
      });
    // clean
    avances.current.setDefaultFilters(); // without persistent filters
  };

  const getAvanceSIC = async value => {
    setBlockingAvances(true);

    const response = await Api.search('dashboards/avances/sic', {
      filter: [
        {
          column: 'id_ciclo',
          operator: '=',
          value: value?.target ? value.target.id : idCiclo,
        },
      ],
    });

    if (response.status == 200) {
      setDataAvances(response.data);
      setDataAvancesTotal(response.data);
    }

    setBlockingAvances(false);
  };

  const getTotalesParcelasCuentas = async value => {
    const resCuentas = await Api.search('cuentas', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: value.target.id },
        { column: 'confirmado', operator: '=', value: 1 },
      ],
      sort: [{ column: 'clave_tx', sort: 'asc' }],
    });

    if (resCuentas.data.length > 0) {
      const totalesParcela = resCuentas.data.reduce((acc, c) => acc + parseInt(c.total_parcelas), 0);
      setTotalesP(totalesParcela);
    }
  };

  const getTipoGrafica = () => {
    switch (tipoGrafica) {
      case 'categoria':
        return <CuentasResumenCategorias id_ciclo={idCiclo} />;
      case 'genero':
        return <CuentasResumenGeneros id_ciclo={idCiclo} />;
      case 'edad':
        return <CuentasResumenEdades id_ciclo={idCiclo} />;
      default:
        break;
    }
  };

  // map methods
  const renderMap = (map, maps) => {
    setMap(map);
    setMaps(maps);
  };

  const onChildClick = (key, childProps) => {
    if (selectedElement && selectedElement.id === childProps.id) {
      onChildUNClick();
    } else {
      setSelectedElement(childProps);
      setActiveMarker(childProps.id);
      setInfoWindowFlag(true);
    }
  };
  const onChildUNClick = () => {
    setSelectedElement(null);
    setActiveMarker(null);
    setInfoWindowFlag(false);
  };

  return (
    <div>
      <div className="mb-2">
        <SelectCiclo
          setFilter={evt => {
            setFilter(evt);
          }}></SelectCiclo>
      </div>
      {Number(usaSic) === 1 ? (
        <>
          {/* dashboard for SIC accounts */}
          <div className="row">
            <div className="col-8">
              <div className="row">
                {/* parcelas registradas card */}
                {/* parcelas geolocalizadas card */}
                <div className="col-12 pr-4 mb-3">
                  <ParcelasResumenTotales parcelas={parcelasAll} blocking={blockingParcelasAll} />
                </div>
              </div>
              {/* barchart for total count levantamiento SIC */}
              <div className="row mt-2">
                <div className="col-12 pr-4">
                  <Panel className="card-table">
                    <AvancesSICCoop dataGraficaMunicipios={dataGraficaMunicipios} dataCuentas={dataCuentas} />
                  </Panel>
                </div>
              </div>
              {/* barchart for total fichas de comité */}
              {usaComiteEvaluacion !== 0 && (
                <div className="row">
                  <div className="col-12 pr-4">
                    <Panel className="card-table">
                      <AvancesComiteCoop dataGraficaMunicipios={dataGraficaMunicipios} />
                    </Panel>
                  </div>
                </div>
              )}
              {/* graph levantamiento de no.productores por municipio y comunidad */}
              <div className="row">
                <div className="col-12 pr-4">
                  <Panel className="card-table">
                    <BlockUi tag="div" message="" blocking={blockingMultiBar} renderChildren={true}>
                      <AvancesSICML
                        isLocalidades={isLocalidades}
                        dataGraficaMunicipios={dataGraficaMunicipios}
                        dataGraficaLocalidades={dataGraficaLocalidades}
                        getAvanceLocalidades={getAvanceLocalidades}
                        setIsLocalidades={setIsLocalidades}
                      />
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          key: env.googleApiKey,
                          libraries: ['geometry', 'elevation'],
                        }}
                        options={map => ({
                          mapTypeId: map.MapTypeId.TERRAIN,
                          rotateControl: true,
                        })}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={() => {}}></GoogleMapReact>
                    </BlockUi>
                  </Panel>
                </div>
              </div>
            </div>
            {/* ultimos registros sic - avance */}
            <div className="col-4">
              <div
                className="row card-dashboard bg-white"
                style={{
                  borderRadius: '20px',
                  padding: '20px 5px',
                }}>
                <BlockUi tag="div" message="" blocking={blockingAvances} renderChildren={true}>
                  <div className="col-12 col-12 pr-0">
                    <h6 className="font-lato-normal-500 heading-box">Últimos registros</h6>
                    {/* search filters with tags - avance */}
                    <AvancesFilters
                      dataAvances={dataAvances}
                      dataAvancesTotal={dataAvancesTotal}
                      setDataAvances={setDataAvances}
                      ref={avances}
                    />

                    {/* records list -avance */}
                    <div className="card-avances-body">
                      {dataAvances.map((avance, i) => (
                        <React.Fragment key={i}>
                          <div className="row" key={avance.id_api_ficha}>
                            <div className="col-7">
                              <small className="text-uppercase">{avance.ficha_title}</small>
                              <p className="mb-0 body-0">
                                <Link
                                  to={{
                                    pathname: `/admin/cuentas/perfil/${avance.uuid_productor}`,
                                  }}
                                  className="m-r-2"
                                  style={{ color: Colors.primary_500 }}>
                                  <span className="text-capitalize">
                                    <u>{avance.nombre_productor.toLowerCase()}</u>
                                  </span>
                                </Link>{' '}
                                - {avance.nombre_parcela}
                              </p>
                              <p>
                                <em className="text-secondary">
                                  Por {avance.nombre_inspector} el {avance.inspeccion_fecha}
                                </em>
                              </p>
                            </div>
                            <div className="col-5 p-0">
                              {avance.reporte == '-' ? (
                                <Link
                                  to={{
                                    pathname: `/admin/parcelas/perfil/${avance.uuid}`,
                                  }}
                                  className="btn btn-sirio btn-outline-secondary btn-md mt-3 pr-4 pl-4 font-lato-normal-500 link-btn"
                                  style={{
                                    borderRadius: '20px',
                                    color: Colors.primary_700,
                                  }}>
                                  Ver croquis
                                </Link>
                              ) : (
                                <LinkDownloadDashboard
                                  url={`pdf/${avance.reporte}/${avance.uuid}`}
                                  label="Descargar ficha"
                                  icon={env.images.icon.pdf}></LinkDownloadDashboard>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </BlockUi>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* dashboard for NO SIC accounts */}
          {dataForKML.length > 0 && (
            <div className="row ">
              <div className="col align-self-end"></div>
              <div className="float-xl-right">
                <p>
                  <img src={env.images.icon.kml} />
                  <a
                    onClick={() => descargaKML(dataForKML, transformWord(etiquetasParcela?.parcela, ['plural', 'lowercase']))}
                    style={{
                      padding: 10,
                      color: '#789D16',
                      cursor: 'pointer',
                    }}>
                    {'Descargar Mapa KML'}
                  </a>
                </p>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-3 col-3 pr-4">
              <CuentasResumenTotales id_ciclo={idCiclo} usaSic={usaSic} />
            </div>
            <div className="col-6 col-6">
              <div className="col-12 col-12 card-dashboard">
                <div className="row">
                  <div className="col-4 col-4">
                    <p className="dashboard-total-productores-text">Productores por:</p>
                  </div>
                  <div className="col-8 col-8">
                    <div className="d-grid gap-2 d-md-block pull-right">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{
                          borderRadius: 10,
                          marginRight: 20,
                          background: tipoGrafica == 'categoria' ? '#FFEED9' : '',
                        }}
                        onClick={() => setTipoGrafica('categoria')}>
                        Categoría
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{
                          borderRadius: 10,
                          marginRight: 20,
                          background: tipoGrafica == 'genero' ? '#FFEED9' : '',
                        }}
                        onClick={() => setTipoGrafica('genero')}>
                        Género
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        style={{
                          borderRadius: 10,
                          marginRight: 20,
                          background: tipoGrafica == 'edad' ? '#FFEED9' : '',
                        }}
                        onClick={() => setTipoGrafica('edad')}>
                        Edad
                      </button> */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-12">{getTipoGrafica()}</div>
                </div>
                {usaSic === 1 && <span style={{ color: '#999' }}>* Los datos mostrados corresponden solol a productores en el padrón</span>}
              </div>
            </div>
            <div className="col-3 col-3 pr-0">
              <div className="row card-category-dashboard" style={{ height: 340 }}>
                <div className="col-12 col-12">
                  <span className="dashboard-total-parcelas-has">{parseInt(totalesP)}</span>
                  <span className="dashboard-titulo-parcelas-has">
                    {transformWord(etiquetas?.parcela, ['plural', 'capitalize'])} totales
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* map */}
          <div className="row">
            <div className="col-12">
              <BlockUi tag="div" message="" blocking={blockingMap} renderChildren={true}>
                <Panel>
                  <PanelBody className="p-0">
                    <div
                      className="row"
                      style={{
                        height: 620,
                        backgroundColor: 'white',
                        borderRadius: '20px 20px 20px 20px',
                        padding: '20px 10px',
                      }}>
                      <div className="col-12 col-12">
                        <div style={{ height: '100%', width: '100%' }}>
                          <GoogleMapReact
                            bootstrapURLKeys={{ key: env.googleApiKey }}
                            options={map => ({
                              mapTypeId: map.MapTypeId.SATELLITE,
                            })}
                            center={center}
                            zoom={zoom}
                            onChildClick={onChildClick}
                            onClick={onChildUNClick}
                            onGoogleApiLoaded={({ map, maps }) => renderMap(map, maps)}>
                            {markers &&
                              markers.map((element, i) => {
                                return (
                                  <MarkerInfoWindowParcela
                                    key={i}
                                    lat={element.centroide_lat}
                                    lng={element.centroide_lng}
                                    color={element.cuenta_categoria_color}
                                    productor={element.cuenta}
                                    parcela={element.parcela_nombre}
                                    superficie={element.parcela_superficie}
                                    id={element.id_parcela}
                                    selectedElement={selectedElement}
                                    showInfoWindow={showInfoWindow}
                                    activeMarker={activeMarker}
                                    link={element.parcela_uuid ? '/admin/parcelas/perfil/' + element.parcela_uuid : null}
                                    linkProductor={element.productor_uuid ? '/admin/cuentas/perfil/' + element.productor_uuid : null}
                                  />
                                );
                              })}
                          </GoogleMapReact>
                        </div>
                      </div>
                    </div>
                  </PanelBody>
                </Panel>
              </BlockUi>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InicioResume;
